import { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';


// axios.interceptors.response.use(
//     function(response) { return response; },
//     function(error) {
//         if (error.response && error.response.data) {
//             if (error.response.data.reason)
//                 error.message = error.response.data.reason;
//
//             error.response = error.response.data;
//         }
//
//         return Promise.reject(error);
//     }
// );


export const useModal = () => {
    const [opened, setOpened] = useState(false);
    const [data, setData] = useState();

    const open = useCallback((data) => {
        setData(data);
        setOpened(true);
    }, [setOpened]);

    const close = useCallback(() => {
        setData(null);
        setOpened(false);
    }, [setOpened]);

    return [opened, open, close, data];
};



export const useFetch = (url, { now = false } = {}) => {
    const [isLoading, setIsLoading] = useState(now);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [options, setOptions] = useState({});

    const doFetch = useCallback((options = {}) => {
        setOptions(options);
        setIsLoading(true);
        setError(null);
    }, []);

    const clearError = useCallback(() => {  // просто для удобства
        setError(null);
    }, [setError]);

    useEffect(() => {
        if (!isLoading || !url) return;

        let skipGetResponseAfterDestroy = false;

        axios(/* baseUrl + */ url, options)
            .then(res => {
                if (!skipGetResponseAfterDestroy) {
                    setResponse(res.data);
                    setIsLoading(false);
                }
            })
            .catch(error => {
                if (!skipGetResponseAfterDestroy) {
                    setError(error);
                    setIsLoading(false);
                }
            });

        return () => {
            skipGetResponseAfterDestroy = true;
        }
    }, [isLoading, url, options]);

    const errorReason = error?.response?.data?.reason;

    return [
        {isLoading, response, error, errorReason},
        {doFetch, setError, clearError}
    ];
};


export const useFetchWithAbort = (url, { now = false } = {}) => {
    const [isLoading, setIsLoading] = useState(now);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [options, setOptions] = useState({});
    const controllerRef = useRef(null);

    const abort = useCallback(() => {
        if (controllerRef.current) {
            controllerRef.current.abort();
        }
    }, []);

    const doFetch = useCallback((opts = {}) => {
        abort();
        controllerRef.current = new AbortController();
        setOptions({ ...opts, signal: controllerRef.current.signal });
        setIsLoading(true);
        setError(null);
    }, [abort]);

    useEffect(() => {
        if (!isLoading || !url) return;

        // ACHTUNG: я не уверен, что эта проверка нужна вместе с abort(). abort() вызовет catch callback и состояние
        // изменится уже после того как компонент был размонтирован, так было нельзя, но мб что-то изменилось
        let skipGetResponseAfterDestroy = false;

        controllerRef.current = new AbortController();
        const signal = controllerRef.current.signal;

        axios(url, { ...options, signal })
            .then((res) => {
                if (!skipGetResponseAfterDestroy) {
                    setResponse(res.data);
                    setIsLoading(false);
                }
            })
            .catch((err) => {
                if (!skipGetResponseAfterDestroy) {
                    if (!axios.isCancel(err) && err.name !== 'CanceledError') {
                        setError(err);
                    }
                    setIsLoading(false);
                }
            });

        return () => {
            skipGetResponseAfterDestroy = true;
            abort();
        };
    }, [isLoading, url, options, abort]);

    return [
        { isLoading, response, error },
        { doFetch, abort, setError }
    ];
};